import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ErrorComponent} from './error/error.component';
import {GoogleAuthorizationComponent} from './google-authorization/google-authorization.component';
import {ViewerComponent} from './viewer/viewer.component';
import {KnowledgeBaseComponent} from './knowledge-base/knowledge-base.component';
import {ViewerNotActiveComponent} from './viewer-not-active/viewer-not-active.component';
import {KnowledgeBaseNotAuthorizedComponent} from './knowledge-base-not-authorized/knowledge-base-not-authorized.component';

const routes: Routes = [
    {
        path: 'after_login',
        children: []
    },
    {
        path: 'google/authorized',
        component: GoogleAuthorizationComponent
    },
    {
        path: 'viewer/event',
        component: ViewerComponent
    },
    {
        path: 'viewer-not-activated',
        component: ViewerNotActiveComponent
    },
    {
        path: 'knowledge-base',
        component: KnowledgeBaseComponent
    },
    {
        path: 'knowledge-base-not-authorized',
        component: KnowledgeBaseNotAuthorizedComponent
    },
    {
        path: 'reset-password',
        loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordModule)
    },
    {
        path: 'set-password',
        loadChildren: () => import('./set-password/set-password.module').then(m => m.SetPasswordModule)
    },
    {
        path: 'privacy-policy',
        loadChildren: () => import('./privacy-policy-page/privacy.module').then(m => m.PrivacyModule)
    },
    {
        path: 'terms-of-service',
        loadChildren: () => import('./terms-of-service-page/terms.module').then(m => m.TermsModule)
    },
    {
        path: 'audio-host-links',
        loadChildren: () => import('./audio-host-links/audio-host-links.module').then(m => m.AudioHostLinksModule)
    },
    {
        path: 'notauthorized',
        component: ErrorComponent
    },
    {
        path: '',
        loadChildren: () => import('./main/main.module').then(m => m.MainModule)
    },

    {
        path: '**',
        component: ErrorComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'top'})],
    exports: [RouterModule]
})

export class AppRoutingModule {

}
